import { pad } from 'viem';

// Assumes given uuid is valid
export const uuidToBytes32 = (uuid: string) => pad(`0x${uuid.replace(/-/g, '')}`, { size: 32 });
